import React from "react";
import { Link } from "react-router-dom";

const Categories = () => {
  return (
    <section className="container py-5">
        <div className="row text-center pt-3">
            <div className="col-lg-6 m-auto">
                <h1 className="h1">Top Personalized Gifts</h1>
                {/*<p>
                    Top Categories of the month
                </p>*/}
            </div>
        </div>
        <div className="row">
            <div className="col-12 col-md-4 p-4 mt-1">
                <Link to="/products/personalized-gifts?sub_categories=sipper-bottle"><img src="/img/gifts/sipper-bottle.png" className="rounded-circle img-fluid border"/></Link>
                <h5 className="text-center mt-3 mb-3">Sipper Bottle</h5>
                <p className="text-center"><Link to="/products/personalized-gifts?sub_categories=sipper-bottle" className="btn btn-success">Go Shop</Link></p>
            </div>
            <div className="col-12 col-md-4 p-4 mt-1">
                <Link to="/products/personalized-gifts?sub_categories=cushions"><img src="/img/gifts/customized-cushion.png" className="rounded-circle img-fluid border"/></Link>
                <h2 className="h5 text-center mt-3 mb-3">Customized Cushion</h2>
                <p className="text-center"><Link to="/products/personalized-gifts?sub_categories=cushions" className="btn btn-success">Go Shop</Link></p>
            </div>
            <div className="col-12 col-md-4 p-4 mt-1">
                <Link to="/products/personalized-gifts?sub_categories=photo-frames"><img src="/img/gifts/photo-frames.png" className="rounded-circle img-fluid border"/></Link>
                <h2 className="h5 text-center mt-3 mb-3">Photo Frames</h2>
                <p className="text-center"><Link to="/products/personalized-gifts?sub_categories=photo-frames" className="btn btn-success">Go Shop</Link></p>
            </div>
        </div>
    </section>
  );
};

export default Categories;
